// @flow

const ko = require('with-global-jquery')(() => require('knockout'));

require('./js/extensions.js');
require('./js/bindings.js');
require('./js/extenders');

import type { KnockoutJS } from './types.js';

export type {
	Accessor,
	Observable,
	Computed,
	PureComputed,
	ObservableArray,
	Constant,
	RgsHtmlTemplate,
	Disposable,
	ObservableFileArray,
	WithRepr,
} from './types.js';

export default (ko: KnockoutJS);
